module.exports = "<web-header></web-header>\n<div class=\"container main\">\n    <ui-view></ui-view>\n</div>\n";